import React from 'react';
import { lazy } from 'react';
import { PageTypes } from 'types/pageType';

const LoginPage = lazy(() => import('containers/auth/login'));
const RegisterPage = lazy(() => import('containers/auth/register'));
const DashboardPage = lazy(() => import('containers/dashboard'));
const SalesPage = lazy(() => import('containers/sales'));
const InventoryPage = lazy(() => import('containers/inventory'));
const ProductsPage = lazy(() => import('containers/products'));
const FundsPage = lazy(() => import('containers/fund'));
const ArchivedStockPage = lazy(
  () => import('containers/products/ArchivedStock')
);
const SettingPage = lazy(() => import('containers/settings'));
const ClientPage = lazy(() => import('containers/clients'));
const ProductCategoryPage = lazy(() => import('containers/productCategory'));
const DebtPage = lazy(() => import('containers/debts'));
const ForgotPasswordPage = lazy(() => import('containers/auth/forgotPassword'));
const PageNotFound = lazy(() => import('pages/PageNotFound'));
const SuppliersPage = lazy(() => import('containers/suppliers'));
const ManageBranchsPage = lazy(() => import('containers/manageBranchs'));
const StockPage = lazy(() => import('containers/stock'));

const FukoWebAppPages: PageTypes = {
  LoginPage: <LoginPage />,
  RegisterPage: <RegisterPage />,
  DashboardPage: <DashboardPage />,
  SalesPage: <SalesPage />,
  InventoryPage: <InventoryPage />,
  ProductsPage: <ProductsPage />,
  FundsPage: <FundsPage />,
  ArchivedStockPage: <ArchivedStockPage />,
  SettingPage: <SettingPage />,
  ClientPage: <ClientPage />,
  ProductCategoryPage: <ProductCategoryPage />,
  DebtPage: <DebtPage />,
  ForgotPasswordPage: <ForgotPasswordPage />,
  PageNotFound: <PageNotFound />,
  SuppliersPage: <SuppliersPage />,
  ManageBranchsPage: <ManageBranchsPage />,
  StockPage: <StockPage />,
};

export default FukoWebAppPages;
